import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

const LoaderRoot = styled('div')(({ theme }) => ({
  inset: '0 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));

export const Loader = () => {
  return (
    <LoaderRoot>
      <CircularProgress />
    </LoaderRoot>
  );
};
